<div class="with-floating-button">
    <div class="content">
        <page-header *ngIf="isDisplayed" [title]="'workflow.motifs.title' | translate" [listeItems]="listeTabItems"></page-header>

        <router-outlet></router-outlet>
    </div>
</div>